// extracted by mini-css-extract-plugin
export default {"maincontent":"RegisterPopup_maincontent__y7DZN","subcontent":"RegisterPopup_subcontent__lFDuU"};